import { ISmartFieldChange } from "@components/smart/smartField/SmartField";
import { createPath } from "@odata/BindingContext";
import {
    IPrCsszHzupnSubmissionEntity,
    PrCsszHzupnSubmissionDetailEntity,
    PrCsszHzupnSubmissionEmployeeEntity,
    PrCsszHzupnSubmissionEntity
} from "@odata/GeneratedEntityTypes";
import { PrSubmissionSubtypeCode, PrSubmissionTypeCode } from "@odata/GeneratedEnums";
import { IdentificationTypeLocalPath, initIdentificationTypeLocalPath } from "@pages/payroll/employee/Employee.utils";
import { PrSubmissionGroup } from "@pages/payroll/submission/Submission.def";
import { setCompanyRelation } from "@pages/payroll/submission/Submission.utils";
import { SubmissionsFormViewForExtend } from "@pages/payroll/submission/SubmissionFormView";
import { hasWorkIntervalsLocalPath } from "@pages/payroll/submission/submissionTypes/PrCsszHzupnSubmission.def";
import {
    addWorkedInDaysIntervalLineItem,
    PrCSSZSubmissionEntity
} from "@pages/payroll/submission/submissionTypes/PrCSSZSubmission.utils";

import { withPermissionContext } from "../../../../contexts/permissionContext/withPermissionContext";
import { FormStorage } from "../../../../views/formView/FormStorage";

class PrCsszHzupnSubmissionFormView extends SubmissionsFormViewForExtend<IPrCsszHzupnSubmissionEntity> {
    typeCode = PrSubmissionTypeCode.ReportingByTheEmployerUponTerminationOfIncapacityForWork;
    subTypeCode: PrSubmissionSubtypeCode = null;
    pathToEmployee = createPath(PrCsszHzupnSubmissionEntity.Employee, PrCsszHzupnSubmissionEmployeeEntity.Employee);

    async typeSpecificOnAfterLoad(isNew: boolean): Promise<void> {
        const { storage } = this.props;
        const entity = storage.getEntity();
        const promises: Promise<void>[] = [];

        if (isNew) {
            promises.push(setCompanyRelation(storage as unknown as FormStorage, { socialFields: true }));
        } else {

        }

        initIdentificationTypeLocalPath(storage,
            storage.data.bindingContext
                .navigate(PrCSSZSubmissionEntity.Employee),
            PrCsszHzupnSubmissionEmployeeEntity.PersonalIdentificationNumber
        );

        await Promise.all(promises);
    }

    handleWorkIntervalSwitchChange = (e: ISmartFieldChange): void => {
        if (e.bindingContext.getPath() === hasWorkIntervalsLocalPath) {
            const { storage } = this.props;

            const isTurnedOn = e.value === true;
            const workedIntervalsBc = storage.data.bindingContext
                .navigate(PrCsszHzupnSubmissionEntity.Detail)
                .navigate(PrCsszHzupnSubmissionDetailEntity.WorkedIntervals);
            if (isTurnedOn) {
                // create first empty line item
                addWorkedInDaysIntervalLineItem(storage, workedIntervalsBc);
            } else {
                // remove all line items
                storage.setValue(workedIntervalsBc, []);
            }
            // refresh whole page to re-render group and show fast entry
            storage.refresh(true);
        }
    };

    handleEmployeeIdentificationTypeChange = (e: ISmartFieldChange): void => {
        const { storage } = this.props;
        const path = e.bindingContext.getPath();
        if (path === IdentificationTypeLocalPath && e.triggerAdditionalTasks) {
            // refresh group to recalculate grouping of fields
            storage.addActiveGroupByKey(PrSubmissionGroup.Employee);
        }
    };

    handleChange(e: ISmartFieldChange) {
        super.handleChange(e);

        this.handleEmployeeIdentificationTypeChange(e);
        this.handleWorkIntervalSwitchChange(e);

        const shouldUpdate = e.triggerAdditionalTasks !== false;
        this.props.storage.refreshFields(shouldUpdate);
    }

    onBeforeSave(data?: IPrCsszHzupnSubmissionEntity): IPrCsszHzupnSubmissionEntity {
        data = super.onBeforeSave(data);

        if (!data.Detail) {
            data.Detail = {};
        }

        return data;
    }
}

export default withPermissionContext(PrCsszHzupnSubmissionFormView);